var _line, _rect, _rect2, _line2, _line3, _line4, _rect3, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrailerBoxOutlineKanan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 290,
    x2: 610,
    y2: 290,
    stroke: "#c7ccd1",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 500,
    height: 150,
    rx: 6,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 132,
    width: 476,
    height: 126,
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 132,
    x2: 200,
    y2: 258,
    stroke: "#1d4256",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 132,
    x2: 320,
    y2: 258,
    stroke: "#1d4256",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 132,
    x2: 440,
    y2: 258,
    stroke: "#1d4256",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 252,
    width: 500,
    height: 18,
    fill: "#1d4256"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 292,
    r: 30,
    fill: "#2a2e33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 292,
    r: 13,
    fill: "#8b9096"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 292,
    r: 30,
    fill: "#2a2e33"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 292,
    r: 13,
    fill: "#8b9096"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerBoxOutlineKanan);
export default __webpack_public_path__ + "static/media/trailer-box-outline-kanan.f4553d5b42068347006c0bead5c0184e.svg";
export { ForwardRef as ReactComponent };